'use client'

import React from 'react'
import styles from './styles.module.css'
import { processStrapiTextTags } from '@/components/StrapiContentRenderer'
import { convertRichTextToHTML } from '@/components/StrapiContentRenderer'

interface DescriptionItem {
  id?: number
  description_item_value?: string
}

interface ListBlockData {
  description?: string | any
  description_item?: DescriptionItem[]
}

interface ListBlockProps {
  data: ListBlockData
}

const processTextWithLineBreaks = (text: string | any): string => {
  if (!text) return ''
  
  let processed = ''
  if (typeof text === 'string') {
    processed = text.replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br>')
    if (processed) {
      processed = `<p>${processed}</p>`
    }
    return processStrapiTextTags(processed)
  }
  
  if (Array.isArray(text)) {
    const html = convertRichTextToHTML(text)
    return processStrapiTextTags(html)
  }
  
  return processStrapiTextTags(String(text))
}

const ListBlock: React.FC<ListBlockProps> = ({ data }) => {
  const description = processTextWithLineBreaks(data.description)
  const items = data.description_item || []

  if (!description && items.length === 0) {
    return null
  }

  return (
    <section className={styles.listBlock}>
      {description && (
        <div 
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {items.length > 0 && (
        <ul className={styles.list}>
          {items.map((item, index) => (
            <li key={item.id || index} className={styles.listItem}>
              {item.description_item_value}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}

ListBlock.displayName = 'ListBlock'

export default ListBlock

